<svg width="101" height="65" viewBox="0 0 101 65" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.3">
    <path
      d="M82.876 0H71.4302C65.1092 0 59.9844 5.14594 59.9844 11.4929V25.859C59.9844 27.445 61.2663 28.7322 62.8458 28.7322H91.4603C93.0398 28.7322 94.3218 27.445 94.3218 25.859V11.4929C94.3218 5.14594 89.1969 0 82.876 0Z"
      fill="#5C6E93" />
    <path
      d="M54.2617 51.7181V45.9717C54.2617 39.6247 59.3866 34.4788 65.7075 34.4788H88.5991C94.92 34.4788 100.045 39.6247 100.045 45.9717V51.7181H54.2617Z"
      fill="#48A5A8" />
    <path
      d="M82.8757 34.4787V25.859H71.4299V34.4787H65.707C65.707 40.8256 70.8319 45.9716 77.1528 45.9716C83.4738 45.9716 88.5986 40.8256 88.5986 34.4787H82.8757Z"
      fill="#D2AA82" />
    <path
      d="M80.0143 28.7322H74.2914C69.55 28.7322 65.707 24.8735 65.707 20.1126V11.4929C65.707 8.318 68.268 5.74646 71.4299 5.74646H74.2914C74.2914 8.92137 76.8524 11.4929 80.0143 11.4929H88.5986V20.1126C88.5986 24.8735 84.7557 28.7322 80.0143 28.7322Z"
      fill="#F0C8A0" />
  </g>
  <g opacity="0.3">
    <path
      d="M28.3166 0H16.9903C10.7354 0 5.66406 5.14501 5.66406 11.4908V25.8543C5.66406 27.44 6.93261 28.727 8.49563 28.727H36.8113C38.3743 28.727 39.6429 27.44 39.6429 25.8543V11.4908C39.6429 5.14501 34.5715 0 28.3166 0Z"
      fill="#5C6E93" />
    <path
      d="M0 51.7086V45.9632C0 39.6174 5.07134 34.4724 11.3263 34.4724H33.9788C40.2337 34.4724 45.3051 39.6174 45.3051 45.9632V51.7086H0Z"
      fill="#48A5A8" />
    <path
      d="M28.3175 34.4723V25.8542H16.9913V34.4723H11.3281C11.3281 40.8181 16.3995 45.9632 22.6544 45.9632C28.9093 45.9632 33.9807 40.8181 33.9807 34.4723H28.3175Z"
      fill="#D2AA82" />
    <path
      d="M25.486 28.727H19.8228C15.1309 28.727 11.3281 24.8689 11.3281 20.1089V11.4908C11.3281 8.31643 13.8624 5.74536 16.9913 5.74536H19.8228C19.8228 8.9197 22.3571 11.4908 25.486 11.4908H33.9807V20.1089C33.9807 24.8689 30.1779 28.727 25.486 28.727Z"
      fill="#F0C8A0" />
  </g>
  <path
    d="M56.8065 2.96741H43.2412C35.7497 2.96741 29.6758 9.04131 29.6758 16.5328V33.4895C29.6758 35.3615 31.1951 36.8809 33.0671 36.8809H66.9806C68.8526 36.8809 70.3719 35.3615 70.3719 33.4895V16.5328C70.3719 9.04131 64.298 2.96741 56.8065 2.96741Z"
    fill="#5C6E93" />
  <path
    d="M22.8906 64.0117V57.229C22.8906 49.7375 28.9645 43.6636 36.456 43.6636H63.5868C71.0783 43.6636 77.1522 49.7375 77.1522 57.229V64.0117H22.8906Z"
    fill="#48A5A8" />
  <path
    d="M56.8051 43.6635V33.4895H43.2397V43.6635H36.457C36.457 51.155 42.5309 57.2289 50.0224 57.2289C57.5139 57.2289 63.5878 51.155 63.5878 43.6635H56.8051Z"
    fill="#D2AA82" />
  <path
    d="M53.4138 36.8809H46.6311C41.0116 36.8809 36.457 32.3263 36.457 26.7069V16.5328C36.457 12.7854 39.4923 9.75012 43.2397 9.75012H46.6311C46.6311 13.4976 49.6663 16.5328 53.4138 16.5328H63.5878V26.7069C63.5878 32.3263 59.0332 36.8809 53.4138 36.8809Z"
    fill="#F0C8A0" />
</svg>